import api from "../libs/api";

export default {
	// MODIFIED: To accept pagination and return the full response object
	getServiceTeams: async (page = 1, itemsPerPage = 15) => {
		try {
			const { status, data } = await api().get(`/service-teams`, {
				params: { page, per_page: itemsPerPage },
			});
			if (status === 200) {
				return data; // Return the whole object { data: [...], total: X, ... }
			}
			throw new Error(`Failed with status: ${status}`);
		} catch (error) {
			throw error; // Re-throw to be handled by the component
		}
	},

	getTeamsByService: (service) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/service-teams/${service}?per_page=5`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateSubCategory: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/software-subcategories/${id}`, data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteSubcategory: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/software-subcategories/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	postAttachTeams: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`services/${id}/teams/attach`, data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
